import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { MenuService } from 'src/app/services/menu.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { ConfiguracionService } from '../../services/configuracion.service';
import { Constantes } from '../../models/modules/Constantes';
import { TamanoAppService } from 'src/app/services/tamanoapp.service';
import { GestionAfiliadoService } from '../../services/gestionafiliado.service';
import { GestionAfiliado } from '../../models/generic/GestionAfiliado';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import { GestionAfiliado_Parametro } from 'src/app/models/generic/GestionAfiliado_Parametro';
import { AutenticacionService } from '../../services/autenticacion.service';
import { ListaAliadosCanales } from 'src/app/models/generic/ListaAliadosCanales';
import { Listas } from 'src/app/models/generic/Listas';
import { ProductosService } from 'src/app/services/productos.service';
import { GestionAfiliadoEdicion } from 'src/app/models/generic/GestionAfiliadoEdicion';
import { GestionAfiliadoEdicionRegistro } from 'src/app/models/generic/GestionAfiliadoEdicionRegistro';
import { GestionAfiliadoBeneficiariosEdicion } from 'src/app/models/generic/GestionAfiliadoBeneficiariosEdicion';
import { ConfirmacionGenericaComponent } from '../confirmaciongenerica/confirmaciongenerica.component';
import { RespuestaGenerica } from 'src/app/models/generic/RespuestaGenerica';

@Component({
  selector: 'gestion-afiliados',
  templateUrl: './gestion-afiliados.component.html',
  styleUrls: ['./gestion-afiliados.component.scss']
})
export class GestionAfiliadosComponent implements OnInit{
  
  form: FormGroup;
  mostrarCargando: boolean = false;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  dataSource: MatTableDataSource<GestionAfiliado>;
  columnasEncabezado: string[] = ['nroDocumento', 'activo', 'fechaAfiliacion', 'nombresApellidos', 'canal', 'aliado', 'producto', 'fechaBaja', 'acciones'];
  listaDatos: GestionAfiliado[] = [];
  @ViewChild('appconfirmacioneliminar', {static: false}) _appconfirmacion: ConfirmacionGenericaComponent;
  itemGestionEliminar: GestionAfiliado;
  
  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public menuService: MenuService,
    public gestionAfiliadoService: GestionAfiliadoService,
    public configuracionService: ConfiguracionService,
    public tamanoAppService: TamanoAppService,
    public autenticacionService: AutenticacionService,
    public productosService: ProductosService) {}

  ngOnInit() {
    this.IniciarFormulario();
  }
  ngAfterViewInit() {
    this.utilitariosService.EstablecerTextoPaginado(this.paginator);
    
    if (this.configuracionInicialService.ConfigLocal.TomarArchivosLocales) {
      this.ConsultarAfiliadosLocal();
    } else {
      if (this.utilitariosService.VerificarContieneDatosTexto(this.menuService.ParametrosAdicionales)) {
        let parametrosAfiliado: GestionAfiliado_Parametro = JSON.parse(this.menuService.ParametrosAdicionales);
    
        this.form.get('nroDocumento').setValue(parametrosAfiliado.nroDocumento);
        this.form.get('nombres').setValue(parametrosAfiliado.nombres);

        if (this.utilitariosService.VerificarContieneDatos(parametrosAfiliado.gestionAfiliado_ListaConsulta)) {
          this.listaDatos = parametrosAfiliado.gestionAfiliado_ListaConsulta;
          this.recargarLista();
        } else if (parametrosAfiliado.consultarDatos && this.utilitariosService.VerificarContieneDatosTexto(parametrosAfiliado.nroDocumento)) {
          this.ConsultarAfiliados();
        }
      } else {
        this.recargarLista();
      }
    }
  }

  IniciarFormulario() {
    this.form = this.fb.group({
      id: [0],
      idProducto: [0],
      nroDocumento: [''],
      nombres: [''],
      Aliado: [''],
      idAplicacion: [0],
      idAliado: [0],
      aliado: [''],
      listaAliadosCanales: [[]]
    });

    this.form.get('idAplicacion').setValue(this.autenticacionService.AplicacionSeleccionadoInicial);
    this.form.get('Aliado').setValue(this.autenticacionService.DescripcionAliadoSeleccionadoInicial);
    this.form.get('idAliado').setValue(this.autenticacionService.CanalSeleccionado);
    this.form.get('aliado').setValue(this.autenticacionService.DescripcionCanalSeleccionado);

    let listaAliadosCanales: ListaAliadosCanales[] = [];
    if (this.utilitariosService.VerificarContieneDatosLista(this.autenticacionService.UsuarioActivo.listaAliados)) {
      for (let index = 0; index < this.autenticacionService.UsuarioActivo.listaAliados.length; index++) {
        let item = this.autenticacionService.UsuarioActivo.listaAliados[index];
        if (this.utilitariosService.VerificarContieneDatosLista(item.listaCanales)) {
          for (let index2 = 0; index2 < item.listaCanales.length; index2++) {
            let itemCanal = item.listaCanales[index2];
            let itemNuevo: ListaAliadosCanales = new ListaAliadosCanales();
            itemNuevo.idAliado = item.idAliado;
            itemNuevo.idCanal = itemCanal.idCanal;
            listaAliadosCanales.push(itemNuevo);
          }
        }
      }
    }
    this.form.get('listaAliadosCanales').setValue(listaAliadosCanales);
  }
  ConsultarAfiliados() {
    if (this.utilitariosService.VerificarContieneDatosTexto(this.form.get('nroDocumento').value)
      || this.utilitariosService.VerificarContieneDatosTexto(this.form.get('nombres').value)) {
      this.mostrarCargando = true;
      this.gestionAfiliadoService.Consultar(this.form.value)
                .subscribe((resp: GestionAfiliado[]) =>{
                  this.mostrarCargando = false;
                  this.listaDatos = resp;
                  this.recargarLista();
                },
                (error: Error) => {
                  this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                  this.mostrarCargando = false;
                  this.cd.detectChanges();
                },
                () => this.cd.detectChanges());
    }
  }
  CancelarRegistro() {
    this.menuService.CambiarComponenteActivo(this.autenticacionService.Componente);
  }
  recargarLista() {
    this.dataSource = new MatTableDataSource(this.listaDatos);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  aplicarFiltro(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  abrirDetalleAfiliado(itemGestion: GestionAfiliado) {
    this.menuService.CambiarComponenteActivo('GestionAfiliadosDetalleComponent', JSON.stringify(this.armarParametroEnvio(itemGestion)));
  }
  abrirDetalleCartera(itemGestion: GestionAfiliado) {
    this.menuService.CambiarComponenteActivo('GestionAfiliadosCarteraComponent', JSON.stringify(this.armarParametroEnvio(itemGestion)));
  }
  armarParametroEnvio(itemGestion: GestionAfiliado): GestionAfiliado_Parametro {
    let parametroAfiliado: GestionAfiliado_Parametro = new GestionAfiliado_Parametro();
    parametroAfiliado.nroDocumento = this.form.get('nroDocumento').value;
    parametroAfiliado.nombres = this.form.get('nombres').value;
    parametroAfiliado.gestionAfiliado_Seleccionado = [];
    parametroAfiliado.gestionAfiliado_Seleccionado.push(itemGestion);
    parametroAfiliado.gestionAfiliado_ListaConsulta = this.listaDatos;
    
    return parametroAfiliado;
  }
  abrirDetalleEstadoAfiliado(itemGestion: GestionAfiliado) {
    if (this.menuService.TienePermisoEscrituraEnMenu('GestionAfiliadosComponent') && itemGestion.registrar) {
      if (this.PermitirEditarEstadoRegistro(itemGestion)) {
        this.menuService.CambiarComponenteActivo('GestionAfiliadosEstadoComponent', JSON.stringify(this.armarParametroEnvio(itemGestion)));
      }
    }
  }
  ConsultarAfiliadosLocal() {
    this.configuracionInicialService.ObtenerConfiguracion(Constantes.CONFIGURACIONLOCAL_GESTIONAFILIADO())
        .subscribe((resp: GestionAfiliado[]) => {
          this.mostrarCargando = false;
          this.listaDatos = resp;
          this.recargarLista();
        },
        (error: Error) => {
          this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
          this.mostrarCargando = false;
          this.cd.detectChanges();
        },
        () => this.cd.detectChanges());
  }
  MostrarTerminosCondiciones(item: GestionAfiliado): boolean {
    return this.utilitariosService.VerificarContieneDatosTexto(item.rutaTerminosCondiciones);
  }
  MostrarControlOperaciones(item: GestionAfiliado): boolean {
    return this.utilitariosService.VerificarContieneDatosTexto(item.rutaControlOperaciones);
  }
  PermitirEditarRegistro(item: GestionAfiliado): boolean {
    let permitirRegistro: boolean = true;
    if (this.utilitariosService.VerificarContieneDatos(item.restringirEdicionRegistro)) {
      if (item.restringirEdicionRegistro) {
        permitirRegistro = false;
      }
    }
    return permitirRegistro;
  }
  PermitirEditarValoresRegistro(item: GestionAfiliado): boolean {
    if (this.menuService.TienePermisoEscrituraEnMenu('GestionAfiliadosComponent') && item.registrar) {
      let permitirRegistro: boolean = this.PermitirEditarRegistro(item);
      if (permitirRegistro) {
        permitirRegistro = item.permiteEditarValoresRegistro;
      }
      return permitirRegistro;
    }

    return false;
  }
  PermitirEditarEstadoRegistro(item: GestionAfiliado): boolean {
    if (this.menuService.TienePermisoEscrituraEnMenu('GestionAfiliadosComponent') && item.registrar) {
      let permitirRegistro: boolean = this.PermitirEditarRegistro(item);
      if (permitirRegistro) {
        permitirRegistro = item.permiteEditarEstadoRegistro;
      }
      return permitirRegistro;
    }

    return false;
  }
  TituloOpcionMenu(): string {
    return this.menuService.ObtenerTituloOpcionComponente('GestionAfiliadosComponent');
  }
  abrirEdicionValoresDetalleRegistro(itemGestion: GestionAfiliado) {
    let formConsulta = this.fb.group({
      idAplicacion: 0,
      id: 0,
    });
    formConsulta.get('idAplicacion').setValue(itemGestion.idAplicacion);
    formConsulta.get('id').setValue(itemGestion.idProductoUnico);

    this.gestionAfiliadoService.ConsultarEdicion(formConsulta.value).subscribe((resp: GestionAfiliadoEdicion[]) => {
      if (resp.length > 0) {
        let itemAsignar: GestionAfiliadoEdicionRegistro = new GestionAfiliadoEdicionRegistro();
        itemAsignar.item = resp[0]
        this.cargarBeneficiariosAfiliado(itemGestion.idAplicacion, itemGestion.idProductoUnico, itemAsignar);
      } else {
        this.utilitariosService.MensajeToast('No existe registro con los datos proporcionados.')
      }
    },(error: Error) => {
      this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
      this.mostrarCargando = false;
      this.cd.detectChanges();
    },
    () => this.cd.detectChanges());
  }
  cargarBeneficiariosAfiliado(idAplicacion: number, idProductoUnico: number, itemAfiliado: GestionAfiliadoEdicionRegistro) {
    let formConsulta = this.fb.group({
      idAplicacion: 0,
      id: 0,
    });
    formConsulta.get('idAplicacion').setValue(idAplicacion);
    formConsulta.get('id').setValue(idProductoUnico);

    this.gestionAfiliadoService.ConsultarEdicionBeneficiario(formConsulta.value).subscribe((resp: GestionAfiliadoBeneficiariosEdicion[]) => {
      itemAfiliado.listaBeneficiarios = resp;
      this.cargarListasGestionAfiliados(idAplicacion, itemAfiliado);
    },(error: Error) => {
      this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
      this.mostrarCargando = false;
      this.cd.detectChanges();
    },
    () => this.cd.detectChanges());
  }
  cargarListasGestionAfiliados(idAplicacion: number, itemAfiliado: GestionAfiliadoEdicionRegistro) {
    let formConsulta = this.fb.group({
      idAplicacion: 0
    });
    formConsulta.get('idAplicacion').setValue(idAplicacion);

    this.configuracionService.CargarListas(formConsulta.value).subscribe((resp: Listas[]) => {
      this.configuracionService.ListasSistema = resp;
      this.AsignarValoresAutenticacion(itemAfiliado);
    },(error: Error) => {
      this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
      this.mostrarCargando = false;
      this.cd.detectChanges();
    },
    () => this.cd.detectChanges());
  }
  AsignarValoresAutenticacion(itemAfiliado: GestionAfiliadoEdicionRegistro) {
    let listaAliados = this.autenticacionService.UsuarioActivo.listaAliados;
    let aliadoSeleccionado = listaAliados.filter(x => x.idAliado === itemAfiliado.item.clialiado_id);
    this.autenticacionService.AplicacionSeleccionado = aliadoSeleccionado[0].idAplicacion;
    this.autenticacionService.AliadoSeleccionado = aliadoSeleccionado[0].idAliado;
    this.autenticacionService.DescripcionAliadoSeleccionado = aliadoSeleccionado[0].aliado;
    if (this.utilitariosService.VerificarContieneDatosNumerico(itemAfiliado.item.clicanal_id)) {
      this.autenticacionService.ListaCanales = aliadoSeleccionado[0].listaCanales;
      let canalSeleccionado = aliadoSeleccionado[0].listaCanales.filter(x => x.idCanal === itemAfiliado.item.clicanal_id);

      this.autenticacionService.CanalSeleccionado = canalSeleccionado[0].idCanal;
      this.autenticacionService.DescripcionCanalSeleccionado = canalSeleccionado[0].canal;
    }
    
    this.abrirEdicionRegistroAliado(itemAfiliado);
  }
  abrirEdicionRegistroAliado(itemAfiliado: GestionAfiliadoEdicionRegistro) {
    itemAfiliado.filtroGestionAfiliado = this.form.get('nroDocumento')?.value;
    this.menuService.CambiarComponenteActivo('RegistrarAfiliadoComponent', JSON.stringify(itemAfiliado));
  }
  AnchoCampoBusqueda(): number {
    if (this.tamanoAppService.mostrarModoCelular) {
      return 150;
    } else if (this.tamanoAppService.mostrarModoTablet) {
      return 170;
    } else {
      return 180;
    }
  }
  HabilitarEliminarRegistro(): boolean {
    return this.autenticacionService.RolEliminarProductoCliente;
  }
  ejecutarEliminarRegistro(itemGestion: GestionAfiliado) {
    this.itemGestionEliminar = itemGestion;
    this._appconfirmacion.MostrarMensajeConfirmacion();
  }
  ConfirmoEliminarUsuario(confirmo: boolean) {
    if (confirmo) {
      this.mostrarCargando = true;
      this.gestionAfiliadoService.EliminarAfiliacion(this.itemGestionEliminar)
        .subscribe((resp: RespuestaGenerica) =>{
          if (!resp.procesoExitoso) {
            this.mostrarCargando = false;
            this.utilitariosService.MensajeToast(resp.mensaje);
          } else {
            this.mostrarCargando = false;
            this.ConsultarAfiliados();
          }
        },
        (error: Error) => {
          this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
          this.mostrarCargando = false;
          this.cd.detectChanges();
        },
        () => this.cd.detectChanges());
    }
  }
}
